module.exports = __webpack_public_path__ + "img/my-invoice.4efabd21.svg";